export function CloseFullScreen({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Compress" transform="translate(48 48) rotate(-180)">
        <rect
          id="Rectangle_3429"
          data-name="Rectangle 3429"
          width="24"
          height="24"
          transform="translate(48 24) rotate(90)"
          fill="none"
        />
        <path
          id="Path_49977"
          data-name="Path 49977"
          d="M1892.778,1005.222,1899,999m0,0h-5.333m5.333,0v5.333"
          transform="translate(-1864.777 -961.222)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <path
          id="Path_49978"
          data-name="Path 49978"
          d="M1889.222,1008.778,1883,1015m0,0h5.333m-5.333,0v-5.333"
          transform="translate(-1845.223 -980.778)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
